import React, { useCallback } from 'react';
import { compact } from '@moda/portal-stanchions';
import { Tag } from '@moda/om';
import classNames from 'classnames';
import { usePLPParams } from '../../hooks/usePLPParams';
import { PageFilterFacetFragment } from '../../generated/types';
import { getMarkdownPercentageItems } from './getMarkdownPercentageItems';

import './SalePercentageTags.scss';

interface SalePercentageTagsProps {
  markdownPercentages: (PageFilterFacetFragment | null)[];
}

export const SalePercentageTags: React.FC<SalePercentageTagsProps> = ({ markdownPercentages }) => {
  const { params, addFilterList, removeFilterList, clearFilter } = usePLPParams();

  const handleClick = useCallback(
    (selectedValue: string[], isSelected: boolean) => {
      if (selectedValue.length === 0) {
        clearFilter('saletags');
      } else {
        if (isSelected) {
          removeFilterList('saletags', selectedValue);
        } else {
          addFilterList('saletags', selectedValue);
        }
      }
    },
    [addFilterList, removeFilterList, clearFilter]
  );

  if (params.section !== 'sale' && !params.sale) return null;

  if (!markdownPercentages) return null;

  const saleFilters = getMarkdownPercentageItems(markdownPercentages, params['saletags']);

  return (
    <div className="SalePercentageTags" data-testid="SalePercentageTags">
      {saleFilters?.map(filter => (
        <Tag
          key={filter.key}
          className={classNames('SalePercentageTags__badge', {
            'SalePercentageTags__badge--active': filter.isSelected
          })}
          onClick={() => handleClick(compact(filter.value), filter.isSelected)}
          data-testid={`SalePercentageTags__badge-${filter.label.replace(' ', '')}`}
        >
          {filter.label}
        </Tag>
      ))}
    </div>
  );
};
